import * as GlobalS from "@/sharedStyled";
import { DEFAULT_FONT_SIZE } from "@/sharedStyled/config";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import {
  NodeModel,
  RenderParams,
  useDragOver,
} from "@minoru/react-dnd-treeview";
import { Card } from "antd";

interface IProps extends RenderParams {
  node: NodeModel;
}
export const OrderableTreeItem = ({
  node: { id, text },
  onToggle,
  isOpen,
}: IProps) => {
  const autoExpandWithDragOver = useDragOver(id, isOpen, onToggle);

  return (
    <Card
      size="small"
      title={
        <>
          <GlobalS.SizedText
            fontSize={DEFAULT_FONT_SIZE}
            className="font-[initial]"
          >
            {text}
          </GlobalS.SizedText>
        </>
      }
      extra={
        <GlobalS.DragIcon
          icon={faBars as IconProp}
          className="float-right p-2"
        />
      }
      styles={{ body: { padding: 0 } }}
      {...autoExpandWithDragOver}
    />
  );
};
